import React, { useState, useEffect, useCallback } from 'react';
import { dietTemplatesService } from '../../services/api';
import { ordenarRefeicoes } from '../PlanoAlimentar/helpers';
import { Ico, emo } from '../ui/Ico';

const BRAND = '#D4A574';

const MEAL_LABEL = {
  cafe_manha: 'Café da manhã', lanche_manha: 'Lanche da manhã', almoco: 'Almoço',
  lanche_tarde: 'Lanche da tarde', jantar: 'Jantar', ceia: 'Ceia',
};

const CAT_ICON = {
  'Idosos': '👴', 'Diabetes Tipo 2': '🩺', 'Hipertensão': '❤️', 'Vegetariano': '🥦',
  'Ovolactovegetariano': '🥚', 'Bariátrica': '⚕️', 'Low Carb': '🥑', 'Sem glúten': '🌾',
};
const iconeCat = (c) => CAT_ICON[c] || '📋';

const kcalDeMeals = (meals) => Math.round(
  Object.values(meals || {}).reduce((s, m) =>
    s + (m.alimentos || []).reduce((x, a) => x + (parseFloat(a.calorias) || 0), 0), 0)
);

const rotulo = (t) => [t.nome, t.kcal_alvo ? `${t.kcal_alvo} kcal` : '', t.variante].filter(Boolean).join(' | ');

export default function CardapiosProntos({ onNavigate }) {
  const [lista, setLista]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [previewId, setPreviewId] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [msg, setMsg]         = useState('');

  const carregar = useCallback(async (termo) => {
    setLoading(true);
    try {
      const r = await dietTemplatesService.getAll(termo || '');
      if (r.success) setLista(r.data || []);
    } catch { /* silenciosa */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { carregar(''); }, [carregar]);
  useEffect(() => {
    const t = setTimeout(() => carregar(search), 300);
    return () => clearTimeout(t);
  }, [search, carregar]);

  const togglePreview = async (id) => {
    if (previewId === id) { setPreviewId(null); setPreviewData(null); return; }
    setPreviewId(id); setPreviewData(null);
    try {
      const r = await dietTemplatesService.get(id);
      if (r.success) setPreviewData(r.data.meals_plan || {});
    } catch { setPreviewData({}); }
  };

  const remover = async (t) => {
    if (!window.confirm(`Remover o modelo "${rotulo(t)}"?`)) return;
    try {
      const r = await dietTemplatesService.delete(t.id);
      if (r.success) { setMsg('Modelo removido.'); carregar(search); }
      else setMsg(r.error || 'Não foi possível remover.');
    } catch { setMsg('Erro ao remover.'); }
  };

  // agrupa por categoria (preservando a ordem do servidor: globais primeiro)
  const grupos = {};
  lista.forEach(t => { (grupos[t.categoria || 'Outros'] = grupos[t.categoria || 'Outros'] || []).push(t); });
  const categorias = Object.keys(grupos);

  return (
    <div style={{ maxWidth: '900px' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        {onNavigate && (
          <button onClick={() => onNavigate('configuracoes')}
            style={{ background: 'none', border: 'none', color: '#736b64', cursor: 'pointer', fontSize: '0.85rem', padding: 0, marginBottom: '0.25rem' }}>
            ← Configurações
          </button>
        )}
        <h1 style={{ margin: '0 0 0.25rem', fontSize: '1.5rem', fontWeight: 700, color: '#2f2a26' }}><Ico e="📋" sp />Cardápios Prontos</h1>
        <p style={{ margin: 0, fontSize: '0.875rem', color: '#736b64' }}>
          Modelos de plano por condição e meta calórica. Aplique-os no editor de plano (botão “<Ico e="📋" sp />Modelos”).
        </p>
      </div>

      <div style={{ background: '#edf4ee', border: '1px solid #b9d2bd', borderRadius: '12px', padding: '0.85rem 1.1rem', marginBottom: '1.25rem', fontSize: '0.85rem', color: '#2f5236' }}>
        <Ico e="💡" sp />Para criar um modelo novo, monte um plano no <strong>Plano Alimentar</strong> e clique em <strong>“<Ico e="⭐" sp />Salvar como modelo”</strong>. Os modelos com <Ico e="🔒" sp />são exemplos do sistema — <strong>revise antes de usar</strong> (não removíveis).
      </div>

      {/* Busca */}
      <div style={{ position: 'relative', marginBottom: '1.25rem' }}>
        <span style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', opacity: 0.4 }}><Ico e="🔍" /></span>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar por nome ou condição..."
          style={{ width: '100%', padding: '0.6rem 0.85rem 0.6rem 2.2rem', border: '1.5px solid #ebe3da', borderRadius: '10px', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }} />
      </div>

      {emo(msg && <div style={{ marginBottom: '1rem', fontSize: '0.85rem', color: '#2f5236', background: '#edf4ee', border: '1px solid #b9d2bd', borderRadius: '9px', padding: '0.6rem 0.9rem' }}>{emo(msg)}</div>)}

      {loading ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#736b64' }}>Carregando modelos…</div>
      ) : categorias.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#736b64' }}>Nenhum modelo encontrado.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {categorias.map(cat => (
            <div key={cat}>
              <h3 style={{ margin: '0 0 0.6rem', fontSize: '1rem', fontWeight: 700, color: '#2f2a26', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span>{emo(iconeCat(cat))}</span> {cat}
                <span style={{ fontSize: '0.78rem', fontWeight: 600, color: '#736b64' }}>({grupos[cat].length})</span>
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {grupos[cat].map(t => (
                  <div key={t.id} style={{ border: `1.5px solid ${previewId === t.id ? BRAND : '#f6f0ea'}`, borderRadius: '11px', overflow: 'hidden' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.75rem 1rem', background: '#fbf8f5' }}>
                      <span style={{ fontSize: '0.62rem', fontWeight: 700, color: '#ffffff', background: t.is_own ? BRAND : '#a39b93', borderRadius: '5px', padding: '3px 6px', flexShrink: 0 }}>
                        {t.is_own ? 'MEU' : 'LN'}
                      </span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: 600, color: '#2f2a26', fontSize: '0.9rem' }}>
                          {emo(t.is_example ? '🔒 ' : '')}{rotulo(t)}
                        </div>
                      </div>
                      <button onClick={() => togglePreview(t.id)}
                        style={{ background: 'none', border: 'none', color: BRAND, fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer' }}>
                        {previewId === t.id ? 'Ocultar' : 'Preview'}
                      </button>
                      {t.is_own && (
                        <button onClick={() => remover(t)}
                          style={{ background: '#f8ebe9', color: '#c46a60', border: 'none', borderRadius: '7px', padding: '0.3rem 0.6rem', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600 }}>
                          <Ico e="🗑" />
                        </button>
                      )}
                    </div>
                    {previewId === t.id && (
                      <div style={{ padding: '0.75rem 1rem', background: '#ffffff', borderTop: '1px solid #ebe3da', fontSize: '0.83rem' }}>
                        {previewData === null ? (
                          <span style={{ color: '#736b64' }}>Carregando…</span>
                        ) : (
                          <>
                            <div style={{ fontWeight: 600, color: BRAND, marginBottom: '0.4rem' }}>≈ {kcalDeMeals(previewData)} kcal · {Object.keys(previewData).length} refeições</div>
                            {ordenarRefeicoes(previewData).filter(([, m]) => m.alimentos?.length).map(([k]) => (
                              <div key={k} style={{ marginBottom: '0.3rem' }}>
                                <span style={{ fontWeight: 600, color: '#4a4440' }}>{emo(MEAL_LABEL[k] || k)}: </span>
                                <span style={{ color: '#736b64' }}>{previewData[k].alimentos.map(a => `${a.alimento} (${a.porcao})`).join(', ')}</span>
                              </div>
                            ))}
                            {t.is_example && <div style={{ marginTop: '0.4rem', color: '#8a5f1a', fontSize: '0.78rem' }}><Ico e="⚠" sp />Modelo-exemplo — revise e ajuste antes de aplicar no paciente.</div>}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
